import { z } from "zod";
import { MetaSchema } from "./shared";

export const OrdersOverviewDataSchema = z.object({
  todayRealizedPnL: z.number(),
  unrealizedPnL: z.number(),
  totalProfit: z.number(),
  totalLoss: z.number(),
  walletBalance: z.string(),
  totalOrders: z.number(),
  openOrders: z.number(),
  closedOrders: z.number(),
  freezeMargin: z.number(),
});

const OrdersOverviewResponse = z.object({
  data: OrdersOverviewDataSchema,
  meta: MetaSchema.default,
});

export type OrdersOverviewResponseType = z.infer<typeof OrdersOverviewResponse>;

export default OrdersOverviewResponse;
